import {useIsBotModeEnabled} from '@aboutyou/data-fetcher';
import {PlaceholderTiles, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const Skeleton = () => {
  const isBotMode = useIsBotModeEnabled();

  if (isBotMode) {
    return (
      <section data-testid="recosLoading">
        <SkeletonBlock $height="100px" />
      </section>
    );
  }

  return (
    <section data-testid="recosLoading">
      {/* lane 1 */}
      <>
        <SkeletonBlock $height="65vh" />
      </>
      <Grid>
        <PlaceholderTiles />
      </Grid>

      {/* lane 2 */}
      <>
        <SkeletonBlock $height="65vh" />
      </>
      <Slider>
        <PlaceholderTiles amount={4} />
      </Slider>

      {/* lane 3 */}
      <>
        <SkeletonBlock $height="65vh" />
      </>
      <Grid>
        <PlaceholderTiles />
      </Grid>
    </section>
  );
};

const Slider = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  > * {
    flex-basis: calc(100% / 2.5);
    margin-right: 5px;
    flex-shrink: 0;
    scroll-snap-align: start;
    margin-right: 5px;
    width: 0px;
  }
`;

const Grid = styled.div`
  padding: 0;
  margin-top: 0.5rem;
  display: grid;
  grid-template-rows: auto;
  grid-gap: 4px;
  width: 100%;
  grid-template-columns: repeat(
    auto-fill,
    minmax(calc((100% - 1 * 4px) / 2), 1fr)
  );
`;
